import React, { useEffect, useState, createElement } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { EcommerceBrands } from './components/EcommerceBrands';
import { LeadForm } from './components/LeadForm';
import { WhyChoose } from './components/WhyChoose';
import { Testimonials } from './components/Testimonials';
import { HowItWorks } from './components/HowItWorks';
import { About } from './components/About';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
export function App() {
  const [language, setLanguage] = useState<'en' | 'es'>('en');
  useEffect(() => {
    // Facebook Pixel initialization
    if ((window as any).fbq) return;
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!(window as any)._fbq) (window as any)._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    (window as any).fbq = n;
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    n('init', '2065268970639767');
    n('track', 'PageView');
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header language={language} setLanguage={setLanguage} data-id="element-1" />
      <Hero language={language} data-id="element-2" />
      <TrustStrip language={language} data-id="element-3" />
      <EcommerceBrands language={language} data-id="element-4" />
      <LeadForm language={language} data-id="element-5" />
      <WhyChoose language={language} data-id="element-6" />
      <Testimonials language={language} data-id="element-7" />
      <HowItWorks language={language} data-id="element-8" />
      <About language={language} data-id="element-9" />
      <Footer language={language} data-id="element-10" />
      <WhatsAppFloat language={language} data-id="element-11" />
      {/* Meta Pixel Noscript Fallback */}
      <noscript data-id="element-12">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2065268970639767&ev=PageView&noscript=1" alt="" data-id="element-13" />
      </noscript>
    </div>;
}